import React from "react";
import ErrorPage from "../Notification/Error";
import History from "./History";
import ProfileComponent from "./Profile";
// import { Link } from "react-router-dom";
import Setting from "./Setting";

function ProfilePage({ props }) {
  const {
    isPersonal,
    onMove,
    isProfile,
    onProfile,
    data,
    update,
    onChange,
    onSubmit,
    province,
    onSelect,
    city,
    district,
    area,
    isError,
    loading,
    onChangePassword,
    onChecking,
    isCheck,
    onView,
    isView,
    onSubmitPassword,
    password,
    isHistory,
    loadingHistory,
    onFilter,
    isMenu,
    onPagination,
    total,
    loadMore,
    onGender,
  } = props;

  return (
    <div className="pro">
      <div className="container mx-auto py-6 lg:py-10">
        {/* Swicth Mode */}
        <div className="flex justify-center lg:justify-start">
          <div className="home-switch w-full lg:w-1/3 px-1 py-2 flex justify-around items-center">
            <div
              onClick={() => onProfile(1)}
              className={`${
                isProfile === 1
                  ? "home-switch-active py-1 px-2 font-semibold"
                  : ""
              } cursor-pointer colors-blue`}
            >
              Profil Saya
            </div>
            <div
              onClick={() => onProfile(0)}
              className={`${
                isProfile === 0
                  ? "home-switch-active py-1 px-2 font-semibold"
                  : ""
              } cursor-pointer colors-blue`}
            >
              Pengaturan
            </div>
            <div
              onClick={() => onProfile(2)}
              className={`${
                isProfile === 2
                  ? "home-switch-active py-1 px-2 font-semibold"
                  : ""
              } cursor-pointer colors-blue`}
            >
              Riwayat Transaksi
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="mt-6 lg:mt-10">
          {/* Header Section */}
          <div name="p-header" className="pro-header p-8 h-32 w-full relative">
            <div className="flex items-center content-center w-full text-white">
              <div className="w-12 h-12 mr-5">
                <img
                  className="w-12 h-12  object-cover rounded-3xl "
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "/assets/image/img_profile.png"
                  }
                  alt="img-profile"
                />
              </div>
              <div>
                <p className="text-base header-title">
                  <b>{data?.first_name ?? ""}</b> {data?.last_name ?? ""}
                </p>
                <p className="text-sm colors-gray header-content">
                  Membership BBLK
                </p>
              </div>
            </div>
            <div className="top-0 left-0  absolute">
              <img
                className="h-20 lg:h-24 object-cover"
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/background/bg_profile_left.svg"
                }
                alt="bg-profile-left"
              />
            </div>
            <div className="top-0 right-0  absolute">
              <img
                className="h-28 object-cover"
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/background/bg_profile_right.svg"
                }
                alt="bg-profile-right"
              />
            </div>
            <div className="top-9 right-10 lg:right-52 absolute">
              <img
                className="h-10 lg:h-28 object-cover"
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/background/bg_profile_orn.svg"
                }
                alt="bg-profile-ornament"
              />
            </div>
          </div>
          <div className="pro-header-second h-12 lg:h-10 -mt-5 px-8 relative">
            <p
              className={`${
                isProfile !== 2 ? "mt-0" : "lg:pt-2 pt-4"
              } text-white pt-2 text-xs lg:text-base header-content`}
            >
              {isProfile !== 2
                ? "Lengkapi profil anda untuk memaksimalkan penggunaan aplikasi"
                : "Anda mempunyai total " + total + " pesanan"}
            </p>
          </div>

          {/* Content Section */}
          <div
            name="p-content"
            className="pro-content  -mt-5 px-4 lg:px-8 pt-12 pb-10"
          >
            {isProfile === 1 ? (
              <ProfileComponent
                props={{
                  isPersonal,
                  onMove,
                  data,
                  update,
                  onChange,
                  province,
                  onSelect,
                  city,
                  district,
                  area,
                  isError,
                  loading,
                  onGender,
                }}
              />
            ) : isProfile === 0 ? (
              <Setting
                props={{
                  onChangePassword,
                  onChecking,
                  isError,
                  loading,
                  isCheck,
                  onView,
                  isView,
                  password,
                }}
              />
            ) : (
              <History
                props={{
                  isHistory,
                  loadingHistory,
                  onFilter,
                  isMenu,
                  onPagination,
                  loadMore,
                }}
              />
            )}

            {/* Check Jika Profile === 3 / Riwayat Transaksi */}
            {isProfile !== 2 && (
              <>
                <div className="flex items-center mb-12">
                  <div className="ml-1 mr-3 lg:mr-4">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_info_blue.svg"
                      }
                      alt="icon-info-blue"
                      className="w-5 lg:w-4"
                    />
                  </div>
                  <p className="colors-gray text-xs lg:text-base header-content">
                    Pastikan profil anda terisi dengan benar, data pribadi anda
                    terjamin keamanannya
                  </p>
                </div>

                {isPersonal === 0 && isError ? (
                  isError.length > 0 ? (
                    <div className="mb-3">
                      <ErrorPage
                        key={1}
                        props={{
                          idx: 1,
                          message:
                            "hai, tolong lengkapi data profil utama kamu terlebih dahulu",
                        }}
                      />
                    </div>
                  ) : null
                ) : null}
                <button
                  disabled={loading || (!isProfile && !isCheck)}
                  onClick={isProfile ? onSubmit : onSubmitPassword}
                  className={`${
                    loading || (!isProfile && !isCheck)
                      ? "btn-loading"
                      : "btn-blue"
                  } w-full  p-3 px-8 focus:outline-none lg:w-96`}
                >
                  <div className="flex items-center justify-between">
                    <div></div>

                    <p className="text-white font-semibold lg:text-lg">
                      {loading ? "Loading" : "Simpan Profil"}
                    </p>
                    <div>
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          (loading || (!isProfile && !isCheck)
                            ? `/assets/icon/ic_save_blue.svg`
                            : `/assets/icon/ic_save.svg`)
                        }
                        alt="icon-save"
                      />
                    </div>
                  </div>
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
